module.exports = __webpack_public_path__ + "img/desk1.7757b987.png";